// src/components/Payment/PaymentSuccess.js
import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';
import { AuthContext } from '../../contexts/AuthContext';

const ChapaPaymentSuccess = () => {
    const { auth } = useContext(AuthContext);
    const navigate = useNavigate();

    // Retrieve tx_ref from localStorage if not provided as a prop
    const initialTxRef = localStorage.getItem('tx_ref') || 'default-tx-ref';
    const [taxRef, setTaxRef] = useState(initialTxRef);

    const token = auth ? auth.accessToken : "there is no token";

    useEffect(() => {
        const executePayment = async () => {
            try {
                const response = await axiosInstance.post('/api/chapa/execute/chapa', { token, tx_ref: taxRef });
                //console.log("response", response.data.status)
                if (response.data.status === 'COMPLETED') {
                    // Clear tx_ref from localStorage after successful payment
                    localStorage.removeItem('tx_ref');
                    navigate('/user-resume');
                } else {
                    // console.error('Payment not completed');
                }
            } catch (error) {
                // console.error('Error executing payment:', error);
            }
        };

        if (token && taxRef) executePayment();
    }, [taxRef, token, navigate]);

    return <div>Processing payment for {taxRef}</div>;
};

export default ChapaPaymentSuccess;
